export const tocStylesObj = {
	ul: "padding-left: 0",
	side_toc: "margin-bottom: 40px;",
};
